import React, { useEffect, useState, useRef, useCallback } from 'react';
import styles from './style.module.css';
import RecognitionCard from './RecognitionCard';
import FooterBox from '../../components/FooterBox';
import FooterForm from '../../components/FooterForm/FooterForm';
import Heading from '../../components/Heading';
import SubHeading from '../../components/SubHeading';
import { WEBApi } from '../../API/WEBApi';
import { Carousel } from 'react-bootstrap';
import VideoCarousel from './VideoCarousel';
import Marquee from "react-fast-marquee";
interface RecognitionItem {
    _id: string;
    image: string;
    title: string;
    url?: string;
    showURL?: boolean;
    date?: any;
    content: string;
}

const Recognition_1 = () => {
    const [recognitions, setRecognitions] = useState<RecognitionItem[]>([]);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    const observer = useRef<IntersectionObserver | null>(null);
    const loaderRef = useRef<HTMLDivElement | null>(null);

    const fetchRecognitions = async (pageNum: number) => {
        setLoading(true);
        try {
            const res = await WEBApi.getPublishedRecognitions(pageNum, 10);
    
            if (res.recognitions && res.recognitions.length > 0) {
                setRecognitions(prev => {
                    const existingIds = new Set(prev.map(item => item._id));
                    const newItems = res.recognitions.filter((item: RecognitionItem) => !existingIds.has(item._id));
                    return [...prev, ...newItems];
                });
            } else {
                // If API returns empty array, mark no more data
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error loading recognitions:", error);
            // Prevent further fetch attempts if API fails
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    };    

    useEffect(() => {
        fetchRecognitions(page);
    }, [page]);

    const handleObserver = useCallback((entries: IntersectionObserverEntry[]) => {
        const target = entries[0];
        if (target.isIntersecting && !loading && hasMore) {
            setPage(prev => prev + 1);
        }
    }, [loading, hasMore]);

    useEffect(() => {
        const option = { root: null, rootMargin: "20px", threshold: 1.0 };
        observer.current = new IntersectionObserver(handleObserver, option);
        if (loaderRef.current) observer.current.observe(loaderRef.current);
        return () => observer.current?.disconnect();
    }, [handleObserver]);

    return (
        <div>
            <div className={'page-top-margin'}>
                <div className='container'>
                    <div className={styles['recongnition-1-main-header-container']}>
                        <div className={styles['recongnition-1-main-header']}>
                            <span className={styles.subtitle}>Press</span>
                            <Heading topBottomMargin={14}>
                                Shaping the Future. One Milestone at a Time
                            </Heading>
                        </div>

                        <div className={styles['marquee-container']}>
                            {/* {loading ? "Loading recognitions..." : "not loading recognitions"} */}
                            {loading && recognitions.length === 0 &&
                                
                                <p className="card-text placeholder-wave">
                                <span className="placeholder col-12"></span>
                            </p>}
                            <Marquee 
                            // className={styles['marquee-track']}
                            >
                                {!(recognitions.length === 0 && loading) && (
                                   recognitions.map((item, idx) => (
                                    <img
                                        key={idx}
                                        src={item.image}
                                        alt="reward"
                                        className={styles['marquee-img']}
                                    />
                                ))
                                )}
                            </Marquee>
                        </div>
                        {/* <Marquee>
                            Hello this is a test for the marquee
                        </Marquee> */}

                        <div className='mt-3'>
                            <VideoCarousel />
                        </div>

                        <SubHeading topBottomMargin={14} style={{ padding: '0px', textAlign: 'center' }}>
                            At BreatheEV, each recognition reinforces our steadfast commitment to advancing smarter, more sustainable mobility solutions.
                            From innovation awards and competitive grants to national media coverage,
                            these milestones reflect the meaningful impact we’re driving in the evolution of electric vehicle charging.
                        </SubHeading>
                    </div>
                    


                    <div className={styles['recongnition-1-container']}>
                        {recognitions.map((item, idx) => (
                            <RecognitionCard
                                key={idx}
                                image={item.image}
                                title={item.title}
                                text={item.content}
                                date={item.date}
                                showURL={item.showURL}
                                url={item.url}
                            />
                        ))}
                        {loading && <div className={styles['page-loader']}> 

                            <div className={`card-text placeholder-wave`}>
                                <span className="placeholder col-12" style={{ height: '10px' }}></span>
                            </div>
                            <div className={`card-text placeholder-wave`}>
                                <span className="placeholder col-12" style={{ height: '10px' }}></span>
                            </div>
                            <div className={`card-text placeholder-wave`}>
                                <span className="placeholder col-12" style={{ height: '10px' }}></span>
                            </div>
                            <div className={`card-text placeholder-wave`}>
                                <span className="placeholder col-12" style={{ height: '10px' }}></span>
                            </div>
                        </div>}
                       

                        <div ref={loaderRef} style={{ height: 10 }}></div>
                    </div>

                </div>
            </div>

            <FooterBox background='#e9ecee'>
                <FooterForm />
            </FooterBox>
        </div>
    );
};

export default Recognition_1;
